import { AddToCartComponent } from '@theme/product-form';

/**
 * Add-to-cart button for the custom Skio subscription buy box.
 *
 * The subscription label ("Get started - <compare> <price>/mo") and the sticky
 * bar price/label are now rendered server-side (`1-add-to-cart-button.liquid`
 * and `sections/1-product-information.liquid`) and kept correct through
 * Horizon's variant-change morph. This element therefore needs no client-side
 * price/label syncing — it exists only to register `<one-add-to-cart-component>`
 * with the base add-to-cart behaviour (fly-to-cart animation, enable/disable)
 * the product form drives via its `addToCartButtonContainer` ref.
 *
 * (Previously this wired to Skio's native widget DOM — `.skio-plan-picker`,
 * `.skio-frequency`, `[skio-subscription-price]` — which the custom
 * `one-plan-picker-component` replaced, so that logic was dead and has been
 * removed.)
 *
 * @extends AddToCartComponent
 */
class OneAddToCartComponent extends AddToCartComponent {}

if (!customElements.get('one-add-to-cart-component')) {
  customElements.define('one-add-to-cart-component', OneAddToCartComponent);
}
